import { CalendarCheck, Mail, MapPin, Phone } from "lucide-react";
import { EMAIL, PHONE_DISPLAY, PHONE_TEL } from "../../lib/constants";
import { HOME_WRAP } from "./HomeShared";
import { useAppointment } from "../../context/AppointmentContext";

export default function ContactSection() {
  const { openAppointment } = useAppointment();

  return (
    <section className={`${HOME_WRAP} pb-16`}>
      <div className="grid min-w-0 gap-5 lg:grid-cols-3 xl:gap-8">
        <a href={`tel:${PHONE_TEL}`} className="flex min-h-[156px] min-w-0 items-start gap-4 rounded-[14px] bg-[#064d7c] px-4 py-6 text-white sm:gap-6 sm:px-6 lg:min-h-[192px] xl:gap-7 xl:px-9">
          <Phone className="h-11 w-11 shrink-0 stroke-[1.8] sm:h-14 sm:w-14" />
          <div className="min-w-0">
            <h3 className="text-[25px] font-bold leading-tight lg:text-[28px]">{PHONE_DISPLAY}</h3>
            <p className="mt-4 max-w-[380px] text-[17px] leading-snug sm:text-[19px] lg:mt-5 lg:text-[21px]">Contact us for appointments and consultations</p>
          </div>
        </a>
        <a href={`mailto:${EMAIL}`} className="flex min-h-[156px] min-w-0 items-start gap-4 rounded-[14px] bg-[#72b7dc] px-4 py-6 text-[#071746] sm:gap-6 sm:px-6 lg:min-h-[192px] xl:gap-7 xl:px-9">
          <Mail className="h-11 w-11 shrink-0 stroke-[1.8] sm:h-14 sm:w-14" />
          <div className="min-w-0">
            <h3 className="break-words text-[16px] font-bold leading-tight min-[390px]:text-[17px] sm:text-[19px] lg:text-[18px] xl:text-[20px] 2xl:text-[22px]">{EMAIL}</h3>
            <p className="mt-4 max-w-[410px] text-[17px] leading-snug sm:text-[19px] lg:mt-5 lg:text-[21px]">Reach out for inquiries, appointments, or support</p>
          </div>
        </a>
        <article className="flex min-h-[156px] min-w-0 items-start gap-4 rounded-[14px] border-2 border-[#071746] bg-white px-4 py-6 text-black sm:gap-6 sm:px-6 lg:min-h-[192px] xl:gap-7 xl:px-9">
          <MapPin className="h-11 w-11 shrink-0 stroke-[1.8] sm:h-14 sm:w-14" />
          <div className="min-w-0">
            <h3 className="text-[24px] font-bold leading-tight lg:text-[26px]">Jamaica</h3>
            <p className="mt-4 max-w-[390px] text-[17px] leading-snug sm:text-[19px] lg:mt-5 lg:text-[21px]">Experience exceptional dental care in a welcoming environment</p>
            <button
              type="button"
              onClick={openAppointment}
              className="mt-5 inline-flex items-center gap-2 text-[15px] font-bold text-[#0052ff] transition hover:text-[#003ec2]"
            >
              <CalendarCheck className="h-4 w-4" />
              Book before you visit
            </button>
          </div>
        </article>
      </div>
      <div className="mt-8 overflow-hidden rounded-[16px] border-2 border-[#064d7c]">
        <iframe
          title="Be Dental Paradise map"
          src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d7962.42591590616!2d-77.50708002234194!3d18.04221503334419!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8edbbf42dc065ebb%3A0x96853e805de56674!2sBe%20Dental%20Paradise!5e0!3m2!1sen!2sin!4v1781177788413!5m2!1sen!2sin"
          className="aspect-[1660/400] min-h-[270px] w-full md:min-h-0"
          allowFullScreen
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        />
      </div>
    </section>
  );
}
